import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  getRayonByOblastForSearch,
  getSettlements,
  getSettlementsBySearchParams,
} from "../../../../redux/directoryMaintenance/settlementsReducer/actionsSettlements";

import GeneralSectionComponent from "../generalSectionComponent";
import SettlementsModal from "./settlementsModal/settlementsModal";

import {
  getRayonByOblId,
  options,
  setOblast,
} from "../../../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import SearchBlockRHF from "../../../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";

import { SETTLEMENTS_COLUMNS } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";

import {
  RESET_SETTLEMENT,
  SET_SEARCH_PARAMS_SETTLEMENTS,
} from "../../../../redux/types";

import styles from "./settlements.module.css";

const Settlements = () => {
  const dispatch = useDispatch();
  const [innerOptions, setInnerOptions] = useState({});
  const [searchParams, setSearchParams] = useState({
    oblast: 0,
    rayon: 0,
    nameRu: "",
  });

  const stateSettlements = useSelector((state) => {
    const { settlementsReducer } = state;
    return settlementsReducer;
  });
  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });

  const handleChange = async (e) => {
    if (e.target) {
      setSearchParams({
        ...searchParams,
        [e.target.dataset.id]: e.target.value,
      });
    } else {
      setSearchParams({ ...searchParams, [e.key]: e.value });
      if (e.key === "oblast") {
        setSearchParams({
          oblast: e.value,
          rayon: 0,
          nameRu: searchParams.nameRu,
        });
        setInnerOptions(await getRayonByOblId(e.value));
      }
    }
  };
  const handleSearch = (e) => {
    e.preventDefault();
    dispatch({
      type: SET_SEARCH_PARAMS_SETTLEMENTS,
      data: searchParams,
    });
    dispatch(getSettlementsBySearchParams(searchParams));
  };

  const handleClear = () => {
    dispatch({
      type: SET_SEARCH_PARAMS_SETTLEMENTS,
      data: { oblast: 0, rayon: 0, nameRu: "" },
    });
    dispatch({
      type: RESET_SETTLEMENT,
    });
    dispatch(
      getSettlementsBySearchParams({
        oblast: 0,
        rayon: 0,
        nameRu: "",
      }),
    );
    setSearchParams({
      oblast: 0,
      rayon: 0,
      nameRu: "",
    });
  };

  useEffect(() => {
    if (dictionaryReducer.allOblast.length > 0) {
      dispatch(getRayonByOblastForSearch(searchParams.oblast));
      setOblast(dictionaryReducer.allOblast);
    }
  }, [dictionaryReducer.allOblast]);

  useEffect(() => {
    if (dictionaryReducer.allOblast) {
      setOblast(dictionaryReducer.allOblast);
    }
  }, []);

  useEffect(() => {
    if (options.inputsSettlements.inputsOptions.rayon.options) {
      setInnerOptions({ ...innerOptions, ...options.inputsSettlements });
    }
  }, [options.inputsSettlements.inputsOptions.rayon.options]);

  useEffect(() => {
    if (!Object.values(innerOptions).length)
      setInnerOptions({ ...options.inputsSettlements });
  }, []);

  return (
    <>
      {Object.values(innerOptions).length && (
        <div className={styles["content-container"]}>
          <SearchBlockRHF
            options={innerOptions}
            handleChange={handleChange}
            handleSearch={handleSearch}
            handleClear={handleClear}
            searchParams={searchParams}
            externalStyles={styles}
          />
          <GeneralSectionComponent
            title=""
            dataFromStateSelector={(state) =>
              state.settlementsReducer.settlements
            }
            getAction={getSettlements}
            headerColumns={SETTLEMENTS_COLUMNS}
            ModalComponent={SettlementsModal}
          />
        </div>
      )}
    </>
  );
};

export default Settlements;
